import React from "react";
import {Route, Routes} from "react-router-dom";

import SignUp from "./SignUp";
import Error from "./Error";
import {Container} from "./elements/layout";
import {ErrorNotification} from "@cb/apricot-react";
import ExchangeToken from "./ExchangeToken";
import Login from "./Login";
import Logout from "./Logout";
import WebAnalyticCookieTest from "./utility/WebAnalyticCookieTest";
import LoginAs from "./LoginAs";
import LoginCSR from "./LoginCSR";
import LogoutCSR from "./LogoutCSR";
import ExchangeTokenCSR from "./ExchangeTokenCSR";
import MismatchError from "./MismatchError.jsx";

const NotFound = () => {
    return (
        <Container pageName="iam-error">
            <ErrorNotification title="Errors." style={{borderRadius: "8px"}}>
                Page Not Found!
            </ErrorNotification>
        </Container>
    );
};

const AppRouters = () => {
    return (
        <>
            <Routes>
                <Route path="/login/error" element={<Error/>}/>
                <Route path="/login/mismatchError" element={<MismatchError/>}/>
                <Route path="/login/signUp" element={<SignUp/>}/>
                <Route path="/login/routeToRegister" element={<SignUp/>}/>
                <Route path="/login/exchangeToken" element={<ExchangeToken/>}/>
                <Route path="/login/login" element={<Login/>}/>
                <Route path="/login/idaasLogin" element={<Login/>}/>
                <Route path="/login/logout" element={<Logout/>}/>
                <Route path="/login/impersonate" element={<LoginAs/>}/>
                <Route path="/login/csrlogin" element={<LoginCSR/>}/>
                <Route path="/login/csrlogout" element={<LogoutCSR/>}/>
                <Route path="/login/exchangeCsrToken" element={<ExchangeTokenCSR/>}/>
                <Route path="/" element={<Login/>}/>
                <Route path="*" element={<NotFound/>}/>

                <Route path="/watest" element={<WebAnalyticCookieTest/>}/>
            </Routes>
        </>
    );
};

export default AppRouters;
